import { type IntlShape } from 'react-intl'

export const nowFormatCountdownTime = (
  intl: IntlShape,
  differenceDate: Date,
): string => {
  return intl.formatTime(differenceDate, {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  })
}
